var LocalStorageWrapper = function () {
  var DomStorageEngine = function DomStorageEngine() {
    var storage = null;
    return {
      isAvailable: function isAvailable() {
        try {
          return 'localStorage' in window && window.localStorage != null;
        } catch (e) {
          return false;
        }
      },
      initialize: function initialize() {
        storage = window.localStorage;
      },
      set: function set(key, value) {
        storage.setItem(key, value);
      },
      remove: function remove(key) {
        storage.removeItem(key);
      },
      getAll: function getAll() {
        var result = {},
            key,
            data;

        for (var i = storage.length; i--;) {
          key = storage.key(i);
          data = storage.getItem(key);
          result[key] = data && data.value ? data.value : data;
        }

        return result;
      }
    };
  };

  var UserDataEngine = function UserDataEngine() {
    var storage = null;
    var ns = 'LS';
    return {
      isAvailable: function isAvailable() {
        return 'addBehavior' in document.documentElement;
      },
      initialize: function initialize() {
        try {
          var link = document.createElement('link'),
              head = document.getElementsByTagName('head')[0];
          storage = head.appendChild(link);
          storage.addBehavior('#default#userData');
          storage.load(ns);
        } catch (e) {}
      },
      set: function set(key, value) {
        try {
          storage.setAttribute(key, value);
          storage.save(ns);
        } catch (e) {}
      },
      remove: function remove(key) {
        try {
          storage.removeAttribute(key);
          storage.save(ns);
        } catch (e) {}
      },
      getAll: function getAll() {
        try {
          var result = {},
              list = storage.XMLDocument.documentElement.attributes,
              key;

          for (var i = 0; i < list.length; i++) {
            key = list[i].name;
            result[key] = storage.getAttribute(key);
          }

          return result;
        } catch (e) {
          return {};
        }
      }
    };
  };

  var FakeDataEngine = function FakeDataEngine() {
    return {
      isAvailable: function isAvailable() {
        return true;
      },
      initialize: function initialize() {},
      set: function set(key, value) {},
      remove: function remove(key) {},
      getAll: function getAll() {
        return {};
      }
    };
  };

  var __prefix = 'LS',
      __defaultNS = 'default',
      __currentEngine = null,
      __cache = {},
      __defaultExpires = +new Date() + 31104000000; // 12 * 30 * 24 * 60 * 60 * 1000;


  function prepareKey(key, ns) {
    return __prefix + '_' + ns + '_' + key;
  }

  var __engines = [DomStorageEngine(), UserDataEngine(), FakeDataEngine()];

  function __getEngine() {
    for (var i = 0; i < __engines.length; i++) {
      if (__engines[i].isAvailable()) return __engines[i];
    }

    return null;
  }

  function getData(engine) {
    var result = {},
        data = engine.getAll(),
        parts,
        fullKey,
        key,
        ns,
        item;

    for (fullKey in data) {
      if (0 === fullKey.indexOf(__prefix)) {
        parts = fullKey.split('_');

        if ((ns = parts[1]) && (key = parts[2])) {
          if (!result[ns]) result[ns] = {};
          item = JSON.parse(data[fullKey]);
          if (item.expires && item.expires < +new Date()) engine.remove(fullKey);else result[ns][key] = item;
        }
      }
    }

    return result;
  }

  function __init() {
    __currentEngine = __getEngine();
    if (!__currentEngine) throw new Error('Не удалось создать storage');

    __currentEngine.initialize();

    __cache = getData(__currentEngine);
  }

  __init();

  return {
    set: function set(key, value, ns, expires) {
      ns = ns || __defaultNS;
      expires = expires || +new Date() + 31104000000; // 12 * 30 * 24 * 60 * 60 * 1000;

      var data = {
        value: value,
        expires: expires
      };

      __currentEngine.set(prepareKey(key, ns), JSON.stringify(data));

      if (!__cache[ns]) __cache[ns] = {};
      __cache[ns][key] = data;
    },
    get: function get(key, ns) {
      ns = ns || __defaultNS;

      if (__cache[ns]) {
        var item = __cache[ns][key];
        if (!item) return null;
        if (item.expires && item.expires < +new Date()) __currentEngine.remove(prepareKey(key, ns));else return item.value;
      }

      return null;
    },
    remove: function remove(key, ns) {
      ns = ns || __defaultNS;

      __currentEngine.remove(prepareKey(key, ns));

      if (__cache[ns]) delete __cache[ns][key];
    },
    hasKey: function hasKey(key, ns) {
      ns = ns || __defaultNS;
      return __cache[ns] && undefined !== __cache[ns][key];
    },
    getKeys: function getKeys(ns) {
      ns = ns || __defaultNS;
      var result = [];
      if (__cache[ns]) for (var key in __cache[ns]) {
        result.push(key);
      }
      return result;
    },
    getNamespaces: function getNamespaces() {
      var result = [];

      for (var key in __cache) {
        result.push(key);
      }

      return result;
    },
    clear: function clear(ns) {
      ns = ns || __defaultNS;

      if (__cache[ns]) {
        for (var key in __cache[ns]) {
          __currentEngine.remove(prepareKey(key, ns));
        }

        delete __cache[ns];
      }
    }
  };
}();

module.exports = {
  LocalStorageWrapper: LocalStorageWrapper
};